import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "@/plugins/vuetify";
import { loadFonts } from "@/plugins/webfontloader";
import axios from "axios";
import router from "./router";
import store from "@/store";
import "@/axiosInterceptor";

import "@/assets/Styling/variable.css";
import "@/assets/Fonts/PtSans.css";
import "@/assets/Fonts/Mulish.css";
import "@/assets/Fonts/Inter.css";
import "@/assets/Fonts/Roboto.css";
import "@/assets/Fonts/Outfit.css";
import "@/assets/Styling/classes.css";
import "@/assets/Styling/Studio.css";
import "@/assets/Styling/style.css";
import "@/assets/Styling/newstyle.css";
import "@/assets/Styling/leftmenu.css";
import "@/assets/Styling/responsive.css";
import "@/assets/Styling/auth.css";
import "@/assets/Styling/charts.css";
import "@/assets/Styling/plotlyModebarRibbon.css";
import "@/assets/Styling/securityModule.css";
import "@/assets/Styling/qaqc.css";
import "@/assets/Styling/darkMode.css";
import "@/assets/Styling/agenticDashboard/agenticDashboard.dark.css";
import "./assets/styles/tokens.css";
import "./assets/styles/layout.css";
import "./assets/styles/vuetify.css";
import "./assets/styles/chrome.css";
import "./assets/styles/filter-drawer.css";
import "./assets/styles/plots.css";
import "./assets/styles/modules/data-management.css";
import "./assets/styles/modules/qaqc.css";
import "./assets/styles/modules/studio.css";
import "./assets/styles/modules/intelligence.css";
import "./assets/styles/modules/agentic.css";
import "./assets/styles/modules/settings.css";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

document.documentElement.classList.add("fd-next");

loadFonts();

store.dispatch("test/initializeActiveTestIndex");
store.dispatch("darkMode/initializeDarkMode");

const app = createApp(App);
app.use(vuetify);
app.use(router);
app.use(store);
app.component("VueDatePicker", VueDatePicker);
app.mount("#app");

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
